var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-lg": "" } },
    [
      _c(
        "v-layout",
        { attrs: { wrap: "" } },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "" } },
            [
              _c(
                "v-slide-y-transition",
                { attrs: { mode: "out-in" } },
                [
                  _c("custom-table", {
                    ref: "customTable",
                    attrs: {
                      "data-url": "/leads/index",
                      "single-item-name": "lead",
                      "plural-item-name": "leads",
                      headers: _vm.headers,
                      freeze: _vm.updating,
                      breakpoint: 950,
                      customClasses: _vm.trClass,
                      "create-button": false,
                      clickable: ""
                    },
                    on: { click: _vm.view },
                    scopedSlots: _vm._u([
                      {
                        key: "row",
                        fn: function(props) {
                          return [
                            _c(
                              "td",
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(props.item.leadReference) +
                                    "\n\n                            "
                                ),
                                props.item.source
                                  ? _c(
                                      "v-tooltip",
                                      {
                                        attrs: { bottom: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "v-icon",
                                                    _vm._g(
                                                      _vm._b(
                                                        {},
                                                        "v-icon",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(
                                                        "\n                                        $mdiInboxArrowDown\n                                    "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(props.item.source_name) +
                                              "\n                                "
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                props.item.promotion
                                  ? _c(
                                      "v-tooltip",
                                      {
                                        attrs: { bottom: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "v-icon",
                                                    _vm._g(
                                                      _vm._b(
                                                        {},
                                                        "v-icon",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(
                                                        "\n                                        $mdiMessageArrowRightOutline\n                                    "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                props.item.promotion.Name
                                              ) +
                                              "\n                                "
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    props.item.leadFirstName +
                                      " " +
                                      props.item.leadLastName
                                  ) +
                                  "\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(props.item.leadCreateDate) +
                                  "\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(props.item.status_name) +
                                    "\n                            "
                                ),
                                typeof props.item.last_comment !==
                                  "undefined" &&
                                props.item.last_comment !== null
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: { icon: "" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.viewComment(props.item)
                                          }
                                        }
                                      },
                                      [
                                        _c("v-icon", [
                                          _vm._v(
                                            "\n                                    $mdiCommentProcessingOutline\n                                "
                                          )
                                        ])
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                typeof props.item.policy !== "undefined" &&
                                props.item.policy !== null
                                  ? _c(
                                      "v-tooltip",
                                      {
                                        attrs: { bottom: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "v-icon",
                                                    _vm._g(
                                                      _vm._b(
                                                        {},
                                                        "v-icon",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(
                                                        "\n                                        $mdiFileDocumentEdit\n                                    "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                props.item.policy
                                                  .PolicyMasterCode
                                              ) +
                                              " - " +
                                              _vm._s(
                                                props.item.policy.plan_details
                                                  .product_name
                                              ) +
                                              "\n                                "
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                typeof props.item.last_quote !== "undefined" &&
                                props.item.last_quote !== null
                                  ? _c(
                                      "v-tooltip",
                                      {
                                        attrs: { bottom: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function(ref) {
                                                var on = ref.on
                                                var attrs = ref.attrs
                                                return [
                                                  _c(
                                                    "v-icon",
                                                    _vm._g(
                                                      _vm._b(
                                                        {},
                                                        "v-icon",
                                                        attrs,
                                                        false
                                                      ),
                                                      on
                                                    ),
                                                    [
                                                      _vm._v(
                                                        "\n                                        $mdiFileDocumentOutline\n                                    "
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("span", [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(
                                                props.item.last_quote
                                                  .reference_number
                                              ) +
                                              " - " +
                                              _vm._s(
                                                props.item.last_quote
                                                  .selected_lpp_label
                                              ) +
                                              " LPP - R" +
                                              _vm._s(
                                                props.item.last_quote
                                                  .total_premium
                                              ) +
                                              "\n                                "
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                typeof props.item.telephonist !== "undefined" &&
                                props.item.telephonist !== null &&
                                typeof props.item.telephonist.FirstName !==
                                  "undefined" &&
                                typeof props.item.telephonist.LastName !==
                                  "undefined"
                                  ? [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            props.item.telephonist.FirstName +
                                              " " +
                                              props.item.telephonist.LastName
                                          ) +
                                          "\n                            "
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "td",
                              [
                                typeof props.item.fo !== "undefined" &&
                                props.item.fo !== null &&
                                typeof props.item.fo.FirstName !==
                                  "undefined" &&
                                typeof props.item.fo.LastName !== "undefined"
                                  ? [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(
                                            props.item.fo.FirstName +
                                              " " +
                                              props.item.fo.LastName
                                          ) +
                                          "\n                            "
                                      )
                                    ]
                                  : _vm._e()
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("td", [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(props.item.dateAppointment) +
                                  "\n                        "
                              )
                            ])
                          ]
                        }
                      },
                      {
                        key: "card",
                        fn: function(props) {
                          return [
                            _vm._l(_vm.headers, function(header, headerIndex) {
                              return _c(
                                "td",
                                {
                                  key: headerIndex,
                                  staticClass: "v-data-table__mobile-row"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "v-data-table__mobile-row__header"
                                    },
                                    [
                                      _vm._v(
                                        "\n                                " +
                                          _vm._s(header.text) +
                                          "\n                            "
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "v-data-table__mobile-row__cell"
                                    },
                                    [
                                      header.value === "names"
                                        ? [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  props.item.leadFirstName +
                                                    " " +
                                                    props.item.leadLastName
                                                ) +
                                                "\n                                "
                                            )
                                          ]
                                        : header.value === "leadReference"
                                        ? [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  props.item.leadReference
                                                ) +
                                                "\n                                    "
                                            ),
                                            props.item.source
                                              ? _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: { bottom: "" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function(ref) {
                                                            var on = ref.on
                                                            var attrs =
                                                              ref.attrs
                                                            return [
                                                              _c(
                                                                "v-icon",
                                                                _vm._g(
                                                                  _vm._b(
                                                                    {},
                                                                    "v-icon",
                                                                    attrs,
                                                                    false
                                                                  ),
                                                                  on
                                                                ),
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                $mdiInboxArrowDown\n                                            "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  },
                                                  [
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            props.item
                                                              .source_name
                                                          ) +
                                                          "\n                                        "
                                                      )
                                                    ])
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            props.item.promotion
                                              ? _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: { bottom: "" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function(ref) {
                                                            var on = ref.on
                                                            var attrs =
                                                              ref.attrs
                                                            return [
                                                              _c(
                                                                "v-icon",
                                                                _vm._g(
                                                                  _vm._b(
                                                                    {},
                                                                    "v-icon",
                                                                    attrs,
                                                                    false
                                                                  ),
                                                                  on
                                                                ),
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                $mdiMessageArrowRightOutline\n                                            "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  },
                                                  [
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            props.item.promotion
                                                              .Name
                                                          ) +
                                                          "\n                                        "
                                                      )
                                                    ])
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        : header.value === "status"
                                        ? [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(props.item.status_name) +
                                                "\n                                    "
                                            ),
                                            typeof props.item.last_comment !==
                                              "undefined" &&
                                            props.item.last_comment !== null
                                              ? _c(
                                                  "v-btn",
                                                  {
                                                    attrs: { icon: "" },
                                                    on: {
                                                      click: function($event) {
                                                        $event.stopPropagation()
                                                        return _vm.viewComment(
                                                          props.item
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v(
                                                        "\n                                            $mdiCommentProcessingOutline\n                                        "
                                                      )
                                                    ])
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            typeof props.item.policy !==
                                              "undefined" &&
                                            props.item.policy !== null
                                              ? _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: { bottom: "" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function(ref) {
                                                            var on = ref.on
                                                            var attrs =
                                                              ref.attrs
                                                            return [
                                                              _c(
                                                                "v-icon",
                                                                _vm._g(
                                                                  _vm._b(
                                                                    {},
                                                                    "v-icon",
                                                                    attrs,
                                                                    false
                                                                  ),
                                                                  on
                                                                ),
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                $mdiFileDocumentEdit\n                                            "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  },
                                                  [
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            props.item.policy
                                                              .PolicyMasterCode
                                                          ) +
                                                          " - " +
                                                          _vm._s(
                                                            props.item.policy
                                                              .plan_details
                                                              .product_name
                                                          ) +
                                                          "\n                                        "
                                                      )
                                                    ])
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            typeof props.item.last_quote !==
                                              "undefined" &&
                                            props.item.last_quote !== null
                                              ? _c(
                                                  "v-tooltip",
                                                  {
                                                    attrs: { bottom: "" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function(ref) {
                                                            var on = ref.on
                                                            var attrs =
                                                              ref.attrs
                                                            return [
                                                              _c(
                                                                "v-icon",
                                                                _vm._g(
                                                                  _vm._b(
                                                                    {},
                                                                    "v-icon",
                                                                    attrs,
                                                                    false
                                                                  ),
                                                                  on
                                                                ),
                                                                [
                                                                  _vm._v(
                                                                    "\n                                                $mdiFileDocumentOutline\n                                            "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      true
                                                    )
                                                  },
                                                  [
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        "\n                                            " +
                                                          _vm._s(
                                                            props.item
                                                              .last_quote
                                                              .reference_number
                                                          ) +
                                                          " - " +
                                                          _vm._s(
                                                            props.item
                                                              .last_quote
                                                              .selected_lpp_label
                                                          ) +
                                                          " LPP - R" +
                                                          _vm._s(
                                                            props.item
                                                              .last_quote
                                                              .total_premium
                                                          ) +
                                                          "\n                                        "
                                                      )
                                                    ])
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        : header.value === "booking_agent"
                                        ? [
                                            typeof props.item.telephonist !==
                                              "undefined" &&
                                            props.item.telephonist !== null &&
                                            typeof props.item.telephonist
                                              .FirstName !== "undefined" &&
                                            typeof props.item.telephonist
                                              .LastName !== "undefined"
                                              ? [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        props.item.telephonist
                                                          .FirstName +
                                                          " " +
                                                          props.item.telephonist
                                                            .LastName
                                                      ) +
                                                      "\n                                    "
                                                  )
                                                ]
                                              : _vm._e()
                                          ]
                                        : header.value === "consultant"
                                        ? [
                                            typeof props.item.fo !==
                                              "undefined" &&
                                            props.item.fo !== null &&
                                            typeof props.item.fo.FirstName !==
                                              "undefined" &&
                                            typeof props.item.fo.LastName !==
                                              "undefined"
                                              ? [
                                                  _vm._v(
                                                    "\n                                        " +
                                                      _vm._s(
                                                        props.item.fo
                                                          .FirstName +
                                                          " " +
                                                          props.item.fo.LastName
                                                      ) +
                                                      "\n                                    "
                                                  )
                                                ]
                                              : _vm._e()
                                          ]
                                        : [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.$refs.customTable.getCardValue(
                                                    props.item,
                                                    header.value
                                                  )
                                                ) +
                                                "\n                                "
                                            )
                                          ]
                                    ],
                                    2
                                  )
                                ]
                              )
                            }),
                            _vm._v(" "),
                            _c(
                              "td",
                              { staticClass: "v-data-table__mobile-row" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "text-center w-full" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        class: _vm.$vuetify.theme.dark
                                          ? "black--text"
                                          : "white--text",
                                        attrs: {
                                          color: _vm.$vuetify.theme.dark
                                            ? "white"
                                            : "primary",
                                          small: "",
                                          small: _vm.isMobile
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.view(props.item)
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                                    View\n                                "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ]
                            )
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { width: "500" },
          on: { "click:outside": _vm.closeComment },
          model: {
            value: _vm.commentDialog,
            callback: function($$v) {
              _vm.commentDialog = $$v
            },
            expression: "commentDialog"
          }
        },
        [
          _vm.tmpLead
            ? _c(
                "v-card",
                [
                  _c("v-card-title", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.tmpLead.last_comment.user_name) +
                        " - " +
                        _vm._s(_vm.tmpLead.last_comment.dateCreated) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("v-card-text", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.tmpLead.last_comment.comment) +
                        "\n            "
                    )
                  ]),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: _vm.$vuetify.theme.dark
                              ? "white"
                              : "primary",
                            text: "",
                            small: _vm.isMobile
                          },
                          on: { click: _vm.closeComment }
                        },
                        [
                          _vm._v(
                            "\n                    Close\n                "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }